import { useEffect, useRef, useState } from "react";
import InvoiceHeader from "../../../../../../../assets/images/Invoice-Hader.png";
// import InvoiceFooter from '../../../../../../assets/images/Invoice-Footer.png'
import InvoiceFooter from "../../../../../../../assets/images/Invoice-Footer.png";
import { Table } from "react-bootstrap";
import { Button } from "react-bootstrap";
import { PDFExport, savePDF } from "@progress/kendo-react-pdf";
import "./MarketplaceInvoice.css";
import { useParams } from "react-router-dom";
import axios from "axios";
import moment from "moment";
import { Markup } from "interweave";

export default function MarketplaceOrderInvoice() {
  const pdfExportComponent = useRef(null);
  const handleButtonClick = (event) => {
    pdfExportComponent.current.save();
  };

  const { id } = useParams();

  const [orderView, setOrderListView] = useState("");

  useEffect(() => {
    axios
      .get(`/api/admin/marketplace/order/product-list/view/${id}`)
      .then((res) => {
        if (res.data.status === 200) {
          setOrderListView(res.data.orderListView);
        }
      });
  }, []);

  return (
    <>
      <PDFExport ref={pdfExportComponent} paperSize="A3">
        <div className="parentInvoice d-flex justify-content-center">
          <div className="containerInvoice">
            <div>
              <img
                src={InvoiceHeader}
                alt=""
                height="160px"
                className="w-100"
              />
            </div>
            <div className="d-flex justify-content-end">
              <div className="my-3">
                <p className="fontText">Order ID: #{orderView?.order_no}</p>
                <p className="fontText">
                  Order Date: {moment(orderView?.created_at).format("LL")}{" "}
                  {moment(orderView?.created_at).format("LT")}
                </p>
              </div>
            </div>
            <div className="viewMargin starAndView">
              <div className="">
                <h4 className="sueprStarHeaderTitle">HelloSuperstars.com</h4>
                <p className="fontText">Adress: Dhaka, Bangladesh</p>
                <p className="fontText">Email: joti@gmail.com</p>
                <p className="fontText">Phone: 01635431430</p>
              </div>
              <div className="">
                <div>
                  <h4 className="sueprStarHeaderTitle">
                    {orderView.user?.first_name} {orderView.user?.last_name}
                  </h4>
                  <p className="fontText">
                    Adress: {orderView?.area}, {orderView.city?.name}, <br />{" "}
                    {orderView.state?.name},{orderView.country?.name}
                  </p>
                  <p className="fontText">Email: {orderView.user?.email}</p>
                  <p className="fontText">Phone: {orderView?.phone}</p>
                  <p className="fontText">Delivery Country: {orderView?.deliverycharge?.country}</p>
                  <p className="fontText">Delivery Company: {orderView?.deliverycharge?.courier_company}</p>
                </div>
              </div>
            </div>
            <div className="tableContainer">
              <Table striped bordered hover>
                <thead className="tableHead">
                  <tr>
                    <th className="fontText">Product Name</th>
                    <th className="fontText">Superstar Name</th>
                    <th className="fontText">Qty</th>
                    <th className="fontText">Unit Price</th>
                    <th className="fontText">Total</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="fontText">{orderView.marketplace?.title}</td>
                    <td className="fontText">
                      {orderView.star?.first_name} {orderView.star?.last_name}
                    </td>
                    <td className="fontText">{orderView?.items}</td>
                    <td className="fontText">$ {orderView?.unit_price}</td>
                    <td className="fontText">
                      $ {orderView?.items * orderView?.unit_price}
                    </td>
                  </tr>
                </tbody>
              </Table>
            </div>

            <div className="grandTotalDiv">
              <div className="starAndView shippingCostDiv">
                <div className="mx-4">
                  <p className="fontText">Sub Total : </p>
                  <p className="fontText">Delivery Charge : </p>
                  <p className="fontText">Total Tax : </p>
                </div>
                <div className="">
                  <p className="fontText">
                    $ {orderView?.items * orderView?.unit_price}
                  </p>
                  <p className="fontText">$ {orderView?.deliverycharge?.courier_charge}</p>
                  <p className="fontText">$ {orderView?.tax}</p>
                </div>
              </div>
            </div>
            <div className="d-flex justify-content-end">
              <div className="underLineTotal"></div>
            </div>
            <div className="d-flex justify-content-end">
              <div className="starAndView">
                <div className="my-2 mx-4">
                  <p>Grand Total : </p>
                </div>
                <div className="my-2">
                  <p>${orderView?.total_price}</p>
                </div>
              </div>
            </div>

            <div className="d-flex justify-content-center">
              <h2 className="thankBussiness">Thank you for your business</h2>
            </div>

            <div className="paymentInfoMargin">
              <h5 className="sueprStarHeaderTitle">Payment Info</h5>
              <p className="fontText">Account: {orderView?.card_no} </p>
              <p className="fontText">A/C Name: {orderView?.holder_name} </p>
              <p className="fontText">Payment status: Paid</p>
            </div>

            <div className="starAndView">
              <div className="">
                <div className="paymentInfoMargin">
                  {" "}
                  <h5 className="sueprStarHeaderTitle">Terms & Conditions</h5>
                  <p className="fontText">
                    <Markup content={orderView.marketplace?.terms_conditions} />
                  </p>
                </div>
              </div>
              <div className="d-flex justify-content-center align-items-center">
                <div>
                  <div className="underLine"></div>
                  <h5 className="mt-2">Authorised Sign</h5>
                </div>
              </div>
            </div>

            <div>
              <img src={InvoiceFooter} alt="" className="w-100" />
            </div>

            <div></div>
          </div>
        </div>
      </PDFExport>

      <div className="d-flex justify-content-center my-4">
        <Button primary={true} onClick={handleButtonClick}>
          Download Pdf
        </Button>
      </div>
    </>
  );
}
